var sliderinterval;
var slidertimeInterval;
var container_class;
var item_class;

function sliderResetSlider() {
  sliderfntExecuteSlide("next");
}

function getElements () {
  let parentTarget = document.getElementsByClassName(container_class);
  return parentTarget[0].getElementsByClassName(item_class);
}

function sliderInitAutoSlider(containerClass, itemClass, time) {
  container_class = containerClass;
  item_class = itemClass;
  slidertimeInterval = time * 1000;
  interval = setInterval('sliderfntExecuteSlide("next")', slidertimeInterval);
  let elements = getElements();
  for (var i = 0; i < elements.length; i++) {
    elements[i].outerHTML = elements[i].outerHTML.replace(
    /x\-background-image/g,
    "background-image"
    );
  }
  sliderResetSlider(containerClass, itemClass);
}

function sliderfntExecuteSlide() {
  sliderResetSlider();
}

function sliderSelectSlide(side) {
  sliderfntExecuteSlide(side);
  clearInterval(sliderinterval);
  interval = setInterval('fntExecuteSlide("next")', slidertimeInterval);
}

function sliderfntExecuteSlide(side) {
  let elements = getElements();
  let curElement, nextElement;

  for (var i = 0; i < elements.length; i++) {
    if (elements[i].style.opacity == 1) {
      curElement = i;
      break;
    }
  }
  if (side == "prev" || side == "next") {
    if (side == "prev") {
      nextElement = curElement == 0 ? elements.length - 1 : curElement - 1;
    } else {
      nextElement = curElement == elements.length - 1 ? 0 : curElement + 1;
    }
  } else {
    nextElement = side;
    side = curElement > nextElement ? "prev" : "next";
  }
  if (elements[curElement]) {
    elements[curElement].style.opacity = 0;
    elements[curElement].style.zIndex = 0;
  }
  if (elements[nextElement]) {
    elements[nextElement].style.opacity = 1;
    elements[nextElement].style.zIndex = 1;
  }
}
